export default __webpack_public_path__ + "static/media/short_dark.844e205a.png";